import { User, Reward, UserReward } from './index';

export interface PendingReward {
  _id?: string;
  nanoid?: string;
  email?: string;
  merchantInitiated?: boolean;
  createdAt?: Date;
  userReward?: UserReward;
  reward?: Reward;
  giftedByUser?: User;
}
